import { Button, Input, Table, Tooltip } from "antd";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { PlusOutlined, AuditOutlined } from "@ant-design/icons";
import axios from "axios";
import { UserInfo } from "../../../../context";
import moment from "moment";
import InventoryReportDetails from "./InventoryReportDetails";

const MerchantInventoryReport = () => {
  const tableLayout = "";
  const scroll = {};
  const [search, setSearch] = useState("");
  const { userData } = useContext(UserInfo);
  const [productInvReport, setProductInvReport] = useState({
    data: [],
    ready: false,
  });
  const [openDetailsDrawer, setOpenDetailsDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const columns = [
    {
      title: "Ref #",
      dataIndex: "transaction_id",
      ellipsis: true,
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Employee",
      // dataIndex: ["employeedetails", "firstname"],
      ellipsis: true,
      render: (text, record) => (
        <p>
          {text.employeedetails.firstname} {text.employeedetails.lastname}
        </p>
      ),
    },
    {
      title: "Status",
      // dataIndex: ["employeedetails", "firstname"],
      ellipsis: true,
      render: (text, record) => (
        <p>{text.remarks === "beginning" ? "BEGINNING" : "ENDING"}</p>
      ),
    },
    {
      title: "Start",
      dataIndex: "start_datetime",
      ellipsis: true,
      render: (text, record) => <p>{moment(text).format("LLL")}</p>,
    },
    {
      title: "End",
      dataIndex: "end_datetime",
      ellipsis: true,

      // align: "center",
      render: (text, record) => <p>{moment(text).format("LLL")}</p>,
    },

    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 40,
      render: (text) => (
        <p style={{ width: window.innerWidth > 883 ? "auto" : 40 }}>
          <Tooltip title="Report Details">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setOpenDetailsDrawer(true);
              }}
              icon={<AuditOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    // loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getProductInventoryReport = useCallback(() => {
    var params = { user_id: userData.data.id, user: "owner" };
    axios
      .get("user/merchant/get/product-inventory-report", { params })
      .then((response) => {
        const data = response.data;
        setProductInvReport({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const searchable = productInvReport.data.filter((data) => {
    return (
      data.employeedetails.firstname
        .toLowerCase()
        .indexOf(search.toLowerCase()) >= 0 ||
      data.employeedetails.lastname
        .toLowerCase()
        .indexOf(search.toLowerCase()) >= 0
    );
  });

  useEffect(() => {
    getProductInventoryReport();
  }, [getProductInventoryReport]);

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 5,
        }}
      >
        <div style={{ flexGrow: 1 }}>
          <Input
            id="search"
            placeholder="Search employee"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              border: "2px solid #e5e5e5",
              width: window.innerWidth < 576 ? "100%" : 300,
            }}
            size="large"
          />
        </div>
        {/* <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => setOpenDrawer(true)}
          //   disabled={productInvReport.data.length >= parseInt(limit)}
        >
          Add Report
        </Button> */}
      </div>

      <Table
        {...tableProps}
        pagination={{
          position: ["bottomCenter"],
        }}
        columns={tableColumns}
        dataSource={searchable.length > 0 ? searchable : []}
        scroll={scroll}
        rowKey={(record) => record.id}
      />

      {openDetailsDrawer && (
        <>
          {selectedData !== null && (
            <InventoryReportDetails
              open={openDetailsDrawer}
              close={() => setOpenDetailsDrawer(false)}
              selectedData={selectedData}
            />
          )}
        </>
      )}
    </>
  );
};

export default MerchantInventoryReport;
